import { api } from './client'
import type { Game, PriceHistory } from '@/types'

export interface GameSearchResult {
  appId: number
  title: string
  price: number
  sale: number | null
  currency: string
  released: string
  headerImageUrl: string
}

export function fetchGame(gameId: string): Promise<Game> {
  return api.get<Game>(`/games/${gameId}`)
}

export function searchGames(query: string): Promise<GameSearchResult[]> {
  return api.get<GameSearchResult[]>(`/games/search?q=${encodeURIComponent(query)}`)
}

export function syncCoopExperience(gameId: string, groupId: string): Promise<void> {
  return api.post<void>(`/games/${gameId}/sync-coop?group_id=${encodeURIComponent(groupId)}`)
}

export function clearGameCache(gameId: string): Promise<void> {
  return api.delete<void>(`/games/${gameId}/cache`)
}

export function fetchPriceHistory(gameId: string): Promise<PriceHistory> {
  return api.get<PriceHistory>(`/games/${gameId}/price-history`)
}
